export default {
    PRIMARY: 'primary',
    MAIN_CTA: 'main-cta',
    SECONDARY: 'secondary',
    TEXT: 'text',
    TEXT_BLACK: 'text-black',
    TEXT_WHITE: 'text-white',
    TEXT_DESTRUCTIVE: 'text-destructive',
    OUTLINE_BLACK: 'outline-black',
    OUTLINE_WHITE: 'outline-white',
    DESTRUCTIVE_PRIMARY: 'destructive-primary',
    DESTRUCTIVE_SECONDARY: 'destructive-secondary',
    CIRCULAR_PRIMARY: 'circular-primary',
    CIRCULAR_MAIN_CTA: 'circular-main-cta',
    CIRCULAR_OUTLINE_BLACK: 'circular-outline-black',
    CIRCULAR_OUTLINE_WHITE: 'circular-outline-white',
    FLOATING: 'floating',
};
